import {React,useState} from 'react';
import  '../Styles/Navbar.css';

export default function Navbar() {
    const [show,setShow] = useState(false);

    const controlNav = () =>{
        if(window.scrollY>90){
            setShow(true)
        }else {
            setShow(false)
        }
    }
        window.addEventListener('scroll', controlNav)
   
    return (
<>
    <header data-testid='navbar' className={show ? 'header__change' : 'header'}>
        <h1 className='logo'> DD </h1>
        <nav>
            <ul className = 'nav__links'>
                <li className='links'><a href ='#about'> About </a></li>
                <li className='links'><a href='#projects'> Projects </a> </li>
                <li className='links'><a href='#clients'> Clients </a></li> 
                <button id='contact__btn'><a href='#contact'> Contact </a></button>
            </ul>
        </nav>
    </header>
</>
    )
}
